module.exports = __webpack_public_path__ + "static/media/study.e7a7e1b4.svg";